export default class NameEmail {
  public name: String;

  public email: String;

  constructor(obj: any = {}) {
    this.name = obj.name || '';
    this.email = obj.email || '';
  }
}
